<template>
    <div class="ur-form-row">
        <!--
        $ver: v0.1.2
        <em>ur-form-row</em>는 자체로 별다른 역할을 하지 않습니다.
        default slot으로 들어오는 content를 그대로 출력해줍니다.
        table의 &lt;tr>역할을 합니다.
        디자인 토큰 중 $ur-form-box__h-divider, $ur-form-row__v-divider값의 변경을 통해
        <em>ur-form-box</em>내부 구분선을 넣고 싶다면 <em>ur-form-row</em>를 적극적으로 활용해야합니다.
        #<em>ur-form-row</em> does not play a role by itself.
        #Print the content coming into the default slot.
        #It acts as & lt;tr> of the table.
        #By changing the value of $ur-form-box__h-divider and $ur-form-row__v-divider among design tokens
        #If you want to put an <em>ur-form-box</em> inner dividing line, you should actively use <em>ur-form-row</em>.
        -->
        <slot/>
    </div>
</template>

<script>
    // ur-form-row는 자체로 별다른 역할을 하지 않습니다. default slot으로 들어오는 content를 그대로 출력해줍니다.
    // table의 <tr>역할을 합니다.
    // 디자인 토큰 중 $ur-form-box__h-divider, $ur-form-row__v-divider값의 변경을 통해
    // ur-form-box내부 구분선을 넣고 싶다면 ur-form-row를 적극적으로 활용해야합니다.
    // #ur-form-row does not play a role in itself. The content coming into the default slot is displayed as it is. Serves as the <tr> of the table.
    // #If you want to put the divider inside the ur-form-box by changing the values ​​of $ ur-form-box__h-divider, $ ur-form-row__v-divider among design tokens,
    // #you must actively utilize ur-form-row.
    export default {
        name: "urFormRow"
    }
</script>
